import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import type { FacturaConfiguracion } from '../models/factura.model';
import { createCachedObservable } from '../utils/cached-observable.util';

/** Respuesta esperada del listado de sociedades / configuraciones emisoras. */
interface ConfiguracionesResponse {
  data: FacturaConfiguracion[];
}

/**
 * Sociedades emisoras (configuraciones de facturación).
 * Endpoint: GET /api/configuraciones — ajustar si el backend usa otra ruta.
 */
@Injectable({ providedIn: 'root' })
export class ConfiguracionesFacturacionService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiUrl}/api`;

  private readonly configuracionesCache = createCachedObservable(() =>
    this.http
      .get<ConfiguracionesResponse>(`${this.baseUrl}/configuraciones`)
      .pipe(map((res) => res.data ?? [])),
  );

  /** GET /api/configuraciones (caché en memoria). */
  getConfiguraciones(): Observable<FacturaConfiguracion[]> {
    return this.configuracionesCache.get();
  }

  clearConfiguracionesCache(): void {
    this.configuracionesCache.clear();
  }
}
